// extracted by mini-css-extract-plugin
export var root = "GenericHeading-root-iKnZ6";
export var rootBreadcrumbs = "GenericHeading-root_breadcrumbs-ew2YE";
export var rootCategory = "GenericHeading-root-category-YRmzc";
export var rootDescription = "GenericHeading-root_description-kwvV4";
export var rootHeading = "GenericHeading-root_heading-Yu7ee";